import {onBeforeUnmount, ref} from "vue";
import {createStream} from "@/services/stream.service";

export default function (params) {
    const stream = ref(null);
    const question = ref("");
    const loading = ref(false);
    const responseId = ref('');
    const rounds = ref([]);
    const systemMessages = ref([]);
    const loaderMessage = ref('');
    const trackingFieldName = params.trackingFieldName ?? 'response_id';

    function sanitizeAnswer(answer) {
        const escaped = loading.value ? answer.replace(/<[^>]*>/g, '') : answer;
        return escaped.replace(/\r\n|\n|\r/g, '<br>');
    }

    function reset() {
        rounds.value = [];
        responseId.value = '';
        loading.value = false;
        systemMessages.value = [];
        loaderMessage.value = '';
    }

    function clearStream() {
        if (stream.value) {
            stream.value.close();
            stream.value = null;
        }
    }

    onBeforeUnmount(clearStream);

    function sendRequest() {
        if (!question.value.trim()) {
            return;
        }

        clearStream();

        const urlParams = new URLSearchParams();

        urlParams.set('question', btoa(unescape(encodeURIComponent(question.value))));

        if (responseId.value?.length) {
            urlParams.set(params.trackingFieldName ?? 'response_id', btoa(unescape(encodeURIComponent(responseId.value))));
        }

        let url = params.url;

        if (url.includes('?')) {
            url += '&' + urlParams.toString();
        } else {
            url += '?' + urlParams.toString();
        }

        stream.value = createStream(url);

        let round = structuredClone(params.roundFormat)

        round.question = question.value;
        rounds.value.push(round);

        if (!stream.value) {
            round.answer = 'Failed to open connection. Please try again.';
            loading.value = false;

            return;
        }

        question.value = '';
        loading.value = true;

        stream.value.onerror = (err) => {
            round.answer = 'Failed to open connection. Please try again.';
            console.error('SSE error', err);
            clearStream();

            // stop loading if connection fails
            loading.value = false;
        };

        stream.value.onmessage = function(event) {
            loaderMessage.value = '';
            round.answer += event.data;
        };

        stream.value.addEventListener('system', function(event) {
            systemMessages.value.push(event.data);
        });

        stream.value.addEventListener('snapshot', function(event) {
            loaderMessage.value = '';
            round.answer = event.data;
        });

        stream.value.addEventListener('loader', function(event) {
            loaderMessage.value = event.data;
            round.answer = '';
        });

        stream.value.addEventListener('done', function(event) {
            const data = JSON.parse(event.data);
            loaderMessage.value = '';

            for (const key in params.roundFormat) {
                if (key in data) {
                    round[key] = data[key];
                }
            }

            responseId.value = data[trackingFieldName];

            loading.value = false;

            clearStream();
        });

        if (params.addEvents) {
            for (const eventName in params.addEvents) {
                stream.value.addEventListener(eventName, function(event) {
                    params.addEvents[eventName](event.data);
                });
            }
        }

        requestAnimationFrame(() => {
            params.content.value.scrollTop = params.content.value.scrollHeight;
        });
    }

    return {
        rounds,
        systemMessages,
        loaderMessage,
        question,
        loading,
        clearStream,
        responseId,
        sendRequest,
        sanitizeAnswer,
        reset,
    }
}
